import { isDefined } from '@sgme/fp';
import type { IScheduledQuotesBlotterItem } from 'apiConnector/scheduledRun/scheduledQuotesBlotter';
import { FieldValueListLayout } from 'components/shared/FieldValueListNext/FieldValueListLayout';
import {
  FieldListFormattedDate,
  FieldListFormattedDatetime,
} from 'components/shared/FieldValueListNext/FieldValueListNext';
import { DaysTriggerDisplay } from 'components/shared/ScheduledRun/shared/DaysTriggerDisplay';
import { FrequencyDisplay } from 'components/shared/ScheduledRun/shared/FrequencyDisplay';
import { ScheduleStatusBadge } from 'components/shared/ScheduledRun/shared/ScheduleStatusBadge';
import { TriggerTimeDisplay } from 'components/shared/ScheduledRun/shared/TriggerTimeDisplay';
import { FormattedMessage } from 'react-intl';
import { connect, type MapStateToProps } from 'react-redux';
import { getSelectedItem } from 'state/blotters/scheduledQuotes';
import type { AppState } from 'state/state.model';
import { TIME_ZONE } from 'utils/core/date';

const mapStateToProps: MapStateToProps<IScheduledQuotesBlotterItem, {}, AppState> = state => getSelectedItem(state)!;
export const ConnectedOverviewTab = connect(mapStateToProps)(OverviewTab);
function OverviewTab({
  name,
  type,
  status,
  triggerTime,
  requester,
  scheduledRangeOrDays: { startDate, endDate, triggerDays },
  frequency,
  nextRunTime,
  lastRunTime,
  timeZone,
  comment,
}: IScheduledQuotesBlotterItem) {
  return (
    <ul className="field-value-list-component list-group list-group-flush" data-e2e="field-value-list">
      <FieldValueListLayout translate label="scheduledRun.title" value={name} />
      <FieldValueListLayout translate label="scheduledRun.type">
        <FormattedMessage id={`scheduledRun.triggerType.resume.${type}`} />
      </FieldValueListLayout>
      <FieldValueListLayout translate label="scheduledRun.status">
        <ScheduleStatusBadge status={status} />
      </FieldValueListLayout>
      <FieldValueListLayout translate label="scheduledRun.triggerTime">
        <TriggerTimeDisplay value={triggerTime} timeZone={timeZone} />
      </FieldValueListLayout>
      <FieldValueListLayout translate label="scheduledRun.creator" value={requester} />
      {triggerDays.length > 0 && (
        <FieldValueListLayout translate label="scheduledRun.days">
          <DaysTriggerDisplay days={triggerDays} />
        </FieldValueListLayout>
      )}
      {isDefined(startDate) && (
        <FieldValueListLayout translate label="scheduledRun.scheduleRange.startDate">
          <FieldListFormattedDate value={startDate} />
        </FieldValueListLayout>
      )}
      {isDefined(endDate) && (
        <FieldValueListLayout translate label="scheduledRun.scheduleRange.endDate">
          <FieldListFormattedDate value={endDate} />
        </FieldValueListLayout>
      )}
      <FieldValueListLayout translate label="scheduledRun.frequency">
        <FrequencyDisplay {...frequency} />
      </FieldValueListLayout>
      {isDefined(nextRunTime) && (
        <FieldValueListLayout translate label="scheduledRun.nextRunTime">
          <FieldListFormattedDatetime value={nextRunTime} timeZone={TIME_ZONE} timeZoneName="short" />
        </FieldValueListLayout>
      )}
      {isDefined(lastRunTime) && (
        <FieldValueListLayout translate label="scheduledRun.lastRunTime">
          <FieldListFormattedDatetime value={lastRunTime} timeZone={TIME_ZONE} timeZoneName="short" />
        </FieldValueListLayout>
      )}
      {isDefined(comment) && (
        <FieldValueListLayout
          fullWidthLabel
          translate
          label="scheduledRun.comment"
          value={comment}
        ></FieldValueListLayout>
      )}
    </ul>
  );
}
